import createIcon from '@/lib/create-icon'

const CyclingIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M11.4999 38.3304C15.7341 38.3304 19.1666 34.9045 19.1666 30.6785C19.1666 26.4524 15.7341 23.0264 11.4999 23.0264C7.26573 23.0264 3.83325 26.4524 3.83325 30.6785C3.83325 34.9045 7.26573 38.3304 11.4999 38.3304Z'
      stroke='url(#paint0_linear_5305_2467)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M11.4999 38.3304C15.7341 38.3304 19.1666 34.9045 19.1666 30.6785C19.1666 26.4524 15.7341 23.0264 11.4999 23.0264C7.26573 23.0264 3.83325 26.4524 3.83325 30.6785C3.83325 34.9045 7.26573 38.3304 11.4999 38.3304Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M11.4999 38.3304C15.7341 38.3304 19.1666 34.9045 19.1666 30.6785C19.1666 26.4524 15.7341 23.0264 11.4999 23.0264C7.26573 23.0264 3.83325 26.4524 3.83325 30.6785C3.83325 34.9045 7.26573 38.3304 11.4999 38.3304Z'
      stroke='url(#paint1_radial_5305_2467)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M34.4999 38.3304C38.734 38.3304 42.1666 34.9045 42.1666 30.6785C42.1666 26.4524 38.734 23.0264 34.4999 23.0264C30.2658 23.0264 26.8333 26.4524 26.8333 30.6785C26.8333 34.9045 30.2658 38.3304 34.4999 38.3304Z'
      stroke='url(#paint2_linear_5305_2467)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M34.4999 38.3304C38.734 38.3304 42.1666 34.9045 42.1666 30.6785C42.1666 26.4524 38.734 23.0264 34.4999 23.0264C30.2658 23.0264 26.8333 26.4524 26.8333 30.6785C26.8333 34.9045 30.2658 38.3304 34.4999 38.3304Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M34.4999 38.3304C38.734 38.3304 42.1666 34.9045 42.1666 30.6785C42.1666 26.4524 38.734 23.0264 34.4999 23.0264C30.2658 23.0264 26.8333 26.4524 26.8333 30.6785C26.8333 34.9045 30.2658 38.3304 34.4999 38.3304Z'
      stroke='url(#paint3_radial_5305_2467)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M11.5 30.6786H19.877C20.5662 30.6786 21.2025 30.3092 21.5431 29.711L29.7083 15.3745'
      stroke='url(#paint4_linear_5305_2467)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M11.5 30.6786H19.877C20.5662 30.6786 21.2025 30.3092 21.5431 29.711L29.7083 15.3745'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M11.5 30.6786H19.877C20.5662 30.6786 21.2025 30.3092 21.5431 29.711L29.7083 15.3745'
      stroke='url(#paint5_radial_5305_2467)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M22.9999 24.9395L13.4166 13.4614M13.4166 13.4614H9.58325M13.4166 13.4614H17.2499'
      stroke='url(#paint6_linear_5305_2467)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M22.9999 24.9395L13.4166 13.4614M13.4166 13.4614H9.58325M13.4166 13.4614H17.2499'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M22.9999 24.9395L13.4166 13.4614M13.4166 13.4614H9.58325M13.4166 13.4614H17.2499'
      stroke='url(#paint7_radial_5305_2467)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M34.6016 30.6109L28.3774 7.72602C31.1581 7.5907 37.1036 7.34245 38.3156 11.9025'
      stroke='url(#paint8_linear_5305_2467)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M34.6016 30.6109L28.3774 7.72602C31.1581 7.5907 37.1036 7.34245 38.3156 11.9025'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M34.6016 30.6109L28.3774 7.72602C31.1581 7.5907 37.1036 7.34245 38.3156 11.9025'
      stroke='url(#paint9_radial_5305_2467)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5305_2467'
        x1='3.83325'
        y1='23.0264'
        x2='21.3398'
        y2='35.207'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5305_2467'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(11.4999 38.3304) scale(7.66667 7.79337)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5305_2467'
        x1='26.8333'
        y1='23.0264'
        x2='44.3398'
        y2='35.207'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5305_2467'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(34.4999 38.3304) scale(7.66667 7.79337)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_5305_2467'
        x1='11.5'
        y1='15.3745'
        x2='29.8359'
        y2='30.5242'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_5305_2467'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(20.6042 30.6786) scale(9.10417 7.79339)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint6_linear_5305_2467'
        x1='9.58325'
        y1='13.4614'
        x2='23.2873'
        y2='24.5855'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint7_radial_5305_2467'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(16.2916 24.9395) scale(6.70833 5.84506)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint8_linear_5305_2467'
        x1='28.3774'
        y1='7.67041'
        x2='43.8194'
        y2='12.316'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint9_radial_5305_2467'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(33.3465 30.6109) scale(4.96905 11.6821)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'CyclingIcon'
)

export default CyclingIcon
